import { useEffect, useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

// Default rental payment terms, pre-filled into rental quotations.
export function RentalDefaultsEditor() {
  const [company, setCompany] = useState(null);
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/company").then((r) => { setCompany(r.data); setText(r.data.default_rental_payment_terms || ""); }).catch(() => {}); }, []);
  if (!company) return null;
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/settings/company", { ...company, default_rental_payment_terms: text }); setCompany(r.data); toast.success("Rental defaults saved"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setSaving(false); }
  };
  return (
    <section className="mt-4 bg-white border border-slate-200 rounded-lg p-5" data-testid="rental-defaults-editor">
      <div className="flex gap-3 mb-3">
        <div className="w-9 h-9 rounded-md bg-sky-50 text-sky-700 flex items-center justify-center shrink-0"><KeyRound className="w-4 h-4" /></div>
        <div>
          <div className="font-semibold text-slate-900">Rental quotation defaults</div>
          <p className="text-sm text-slate-500 mt-1">Payment terms pre-filled when a quotation (or option) is set to a Rental type. Editable on each quotation.</p>
        </div>
      </div>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} className="w-full border border-slate-200 rounded-md p-2 text-sm" data-testid="rental-payment-terms-default" />
      <div className="flex justify-end mt-3">
        <Button onClick={save} disabled={saving || !text.trim()} className="bg-indigo-600 hover:bg-indigo-700" data-testid="rental-defaults-save">{saving ? "Saving…" : "Save"}</Button>
      </div>
    </section>
  );
}
